import React from 'react';
import { Header } from 'semantic-ui-react';
import CartSummary from '../CartSummary';
import { CartPropType } from '../CartSummary/CartSummary.propTypes';
import './SuccessfulCheckoutConfirmation.css';
var defaultProps = {
  tip: 0.0
};
function SuccessfulCheckoutConfirmation(_ref) {
  var cart = _ref.cart,
    tip = _ref.tip;
  return /*#__PURE__*/React.createElement(CartSummary, {
    cart: cart,
    readOnly: true,
    displayHeaderOptions: false,
    tip: tip,
    header: /*#__PURE__*/React.createElement(Header, {
      as: "h2",
      className: "successful-checkout-confirmation-header"
    }, /*#__PURE__*/React.createElement(Header.Content, null, "Order Confirmed"))
  });
}
SuccessfulCheckoutConfirmation.defaultProps = defaultProps;
export default SuccessfulCheckoutConfirmation;